import React,{useContext} from 'react';
import { FormGroup, FormHelperText, InputBase } from "@material-ui/core";
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { PaymentModes } from '../../utils';
import i18next from  'i18next';
import {PaymentMode} from '../../App';

function PostalCode({ formik, className, isApmShown}) {
  const paymentMode = useContext(PaymentMode);
  const classes = useStyles();
  const {t} = useTranslation();
  let pCode = formik.values.country === 'GB' ? `${t('Postal')} ${t('code')}` : `${t('ZIP')}`
  const isShown = ((formik.values.country === 'US' || formik.values.country === 'GB') && paymentMode !==PaymentModes.Token) || isApmShown;
  if (isShown) {
    return (
      <>
        <FormGroup className={className}>
          <p className={`${classes.postalText} input_label_text`}>{formik.values.country === 'GB' ? `${t('Postal')} ${t('code')}` : `${t('ZIP')}`}</p>
          <InputBase
            error={formik.errors?.zip  && formik.touched?.zip}
            label={pCode}
            name="zip"
            value={formik.values.zip}
            placeholder= {pCode}
            variant="outlined"
            required
            fullWidth
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            inputProps={formik.values.country === 'GB' ? { maxLength: 9 } : { maxLength: 5 }}
          />
          {
            formik.errors?.zip && formik.touched?.zip && (
              <FormHelperText className='error_text' error>{formik.errors?.zip}</FormHelperText>
            )
          }
        </FormGroup>
      </>
    );
  } else return null;
}

export default PostalCode;
